/**
 * 3P coding agents offered on the WAC confirmation page.
 *
 * Launch list:
 *  - GitHub Copilot for Jira
 *  - Claude
 *  - Cursor
 *  - Codex
 */
export const CODING_AGENT_IDS = {
    githubCopilot: "github_copilot",
    claude: "claude_code",
    cursor: "cursor",
    codex: "codex"
} as const;

export type CodingAgentId =
    (typeof CODING_AGENT_IDS)[keyof typeof CODING_AGENT_IDS];

export const ALL_CODING_AGENT_IDS: CodingAgentId[] =
    Object.values(CODING_AGENT_IDS);
